import { createFileRoute } from '@tanstack/react-router';

import { PcbPage } from '@/areas/settings/pcb/Settings/PcbPage/PcbPage';
import { canViewDesignSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/pcb/')({
    staticData: {
        access: { permissions: canViewDesignSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PcbPage />;
}
